import { WORKSPACE_FRAGMENT } from 'features/workspace'
import { Ability } from 'providers/casl'
import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, VariablesDTO } from './types'

export const UPDATE_CURRENT_WORKSPACE = (
  ability: Ability,
): TypedDocumentNode<Data, { input: VariablesDTO }> => gql`
  ${WORKSPACE_FRAGMENT(ability)}
  ${ERROR_FRAGMENT}

  mutation updateCurrentWorkspace($input: UpdateCurrentWorkspaceInput!) {
    updateCurrentWorkspace(input: $input) {
      user {
        id
        currentWorkspace {
          ...WorkspaceFragment
        }
        currentWorkspaceRole
        workspaceProducts {
          product
          status
        }
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
